<template>
  <div id="about" class="forwarding-receipt-main">
    <div class="flex flex-space-between forwarding-receipt-main-wrapper">
      <div class="forwarding-receipt-main-data">
        <div v-html="data.description" />
      </div>
      <public-card-info
        img-url="/images/pages/forwarding-receipt/phone.png"
      >
        {{ data.cardText }}
        <vz-button
          large
          variant="primary"
          @click="openVzFeedbackCallModal"
        >
          Оставить заявку
        </vz-button>
      </public-card-info>
    </div>
  </div>
</template>

<script setup lang="ts">
import PublicCardInfo from '~/components/public/public-card-info.vue'
import {getPageContent} from '~/api/content';

const {$showDialog} = useNuxtApp()

const data = (await getPageContent('/forwarding-receipt')).blocks?.about

const preset = {
  typeId: '136469d9-dd51-485c-b404-122634bac2a6',
  message: 'Подключение электронной экспедиторской расписки',
  isShort: true
}

function openVzFeedbackCallModal(): void {
  $showDialog({ name: 'feedback', preset: preset })
}
</script>
